var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['page-head fixed-top p-3', {
    'with-members': _vm.withMembers
  }]},[_c('h1',{staticClass:"page-head__heading"},[(_vm.hasBack)?_c('div',{staticClass:"page-head__back",on:{"click":_vm.back}},[_c('span',{staticClass:"material-icons"},[_vm._v(" arrow_back_ios ")])]):_vm._e(),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }